import React, { ReactElement, useRef, useEffect, useMemo, useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { View, Text, TouchableWithoutFeedback } from 'react-native';
import { KImage, KSwiper, KView, PageContext } from '@/component/RtlLayout';

import { convertStyles } from '@kibt/krn-utils';
import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);

import MyImage from '../MyImage';
import CropImage from '@/business-components/CropImage';
import CloseWithBackground from '@/assets/icon_detail/closeWithBackground.png';

import ImagePreview from '@kibt/meta-ui-krn/lib/components/ImagePreview';
import { logShowImgContiner, logClickImgContiner, logShowImgFullScreenContiner, logShowCommentImage } from '../../../logger2.0';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { scaleW, vw, vwWithPC } from '@/common/style';
import { useEntranceType, useIsHalfWebView } from '../../const';
import { useShowProductBenifits } from '@/hooks/abTest/useShowProductBenifits';
import { useDetailPageStore } from '@/page/detail/store';
import shoppingBag from '@/assets/images/shoppping-bag.png';
import { CommentImage } from '../CommentImageV2';
import { radar } from '@/common/log';
import { GoodsBenefitBanner, IBannerType } from '@/component/GoodsBenefit';
import { Box } from '@kibt/meta-ui-krn';
import SwiperVideo, { PreviewVideo } from '../Video';
import { useMemoizedFn } from 'ahooks';
import { RankImage } from '../RankImage';
import { isMobileDeviceValue, PCMaxWidth } from '@/common/device-info';

const SwiperLine = (): ReactElement => {
    const { productBenifits, showBenifitsFun } = useShowProductBenifits();
    // Swiper 组件 包含 swiper和大图预览
    // 不在本组件内部维护索引 索引交给父组件

    const { swiperImageIndex, pageRawData, setVideoStatus, videoStatus, showVideo, specImageIndex } = useDetailPageStore(s => ({
        swiperImageIndex: s.swiperImageIndex,
        pageRawData: s.pageRawData,
        setVideoStatus: s.setVideoStatus,
        videoStatus: s.videoStatus,
        showVideo: s.showVideo,
        specImageIndex: s.specImageIndex,
    }));
    const setStoreState = useDetailPageStore().setState;
    const getStoreState = useDetailPageStore().getState;
    const ifSendShowCommentImage = useRef(false);

    const ImageUrlsArr = useMemo(() => {
        let arr;
        if (pageRawData && pageRawData.imageUrls) {
            const arrName = pageRawData?.templateImageUrls && pageRawData.templateImageUrls?.length ? 'templateImageUrls' : 'imageUrls';
            const sigNalName = 'templateImageUrl';
            arr = JSON.parse(JSON.stringify(pageRawData[arrName]));
            // 如果只有一个sku，并且该sku有图片，不把该图片添加到swiper里面，@zhangyi
            if (
                pageRawData &&
                pageRawData?.skus?.length > 1 &&
                pageRawData.specs?.[0] &&
                pageRawData.specs[0].itemSpecValues[0].imageUrl &&
                pageRawData.specs[0].itemSpecValues[0].imageUrl !== ''
            ) {
                pageRawData.specs[0].itemSpecValues.forEach(item => {
                    // item.imageUrl兜底
                    arr.push(item[sigNalName] || item.imageUrl);
                });
            }
        }
        return arr;
    }, [pageRawData]);

    const setSpecImageIndex = index => {
        setStoreState({
            specImageIndex: Math.max(index - getStoreState().detailImageurls.length, -1),
        });
    };

    useEffect(() => {
        if (!pageRawData.comments?.length || ifSendShowCommentImage.current) return;
        if (pageRawData?.abTest?.wordOfMouth && pageRawData?.comments?.length >= 2) {
            if (swiperImageIndex === ImageUrlsArr?.length && !ifSendShowCommentImage.current) {
                ifSendShowCommentImage.current = true;
                logShowCommentImage(pageRawData.comments?.map(comment => comment?.productScore));
            }
        }
    }, [swiperImageIndex, ImageUrlsArr, pageRawData.comments, pageRawData?.abTest?.wordOfMouth]);

    const ENTRANCETYPE = useEntranceType();
    const isHalfWebView = useIsHalfWebView();

    const clickImgContiner = (index, type) => {
        logClickImgContiner({
            index,
            type,
            itemId: pageRawData.itemId,
            entranceType: ENTRANCETYPE,
            isHalfWebView,
            image_type: index < pageRawData.imageUrls.length ? 1 : 0,
        });
    };

    const [showImageViewer, setShowImageViewer] = useState(false);

    // 商品主图利益点标签图片透出
    const benifitRender = useMemo(() => {
        if (pageRawData?.priceDiscountDetail?.shippingDisplayMinThresholdDesc) {
            // 包邮表达调整优化 https://docs.corp.kuaishou.com/d/home/fcACrwhBjl2d8D9Ny2C6FJasy
            const benefitInfo = {
                style: {
                    bgImg: 'https://cdn-static.kwai.net/kos/s101/nlav11312/detail_shipping_banner_banner.acc52d8290f0e842.png',
                    activityColor: 'rgba(255, 255, 255, 1)',
                    activityIcon: 'https://cdn-static.kwai.net/kos/s101/nlav11312/detail_shipping_banner_icon.12981c7d29a8c93f.png',
                },
                girdleModule: {
                    name: pageRawData?.priceDiscountDetail?.shippingDisplayMinThresholdDesc ?? '',
                    countDownMills: 0,
                },
            };
            return (
                <Box bs={{ position: 'absolute', bottom: 0, w: '100%' }}>
                    <GoodsBenefitBanner benefitInfo={benefitInfo} bannerType={IBannerType.Detail} />
                </Box>
            );
        }
        return null;
    }, [showBenifitsFun, productBenifits, pageRawData]);
    const renderSwiperItem = ({ item, index }) => {
        // 用于渲染组件
        if (typeof item !== 'string') return item;
        if (!ImageUrlsArr || !ImageUrlsArr.length) {
            return null;
        }

        if (ImageUrlsArr && ImageUrlsArr.length > 1) {
            return (
                <View
                    style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: isMobileDeviceValue ? '100%' : PCMaxWidth,
                        height: '100%',
                        position: 'relative',
                    }}
                    key={item}>
                    <TouchableWithoutFeedback
                        onPress={() => {
                            // 轮播图片点击业务埋点
                            radar.event({
                                name: 'detail_image_click',
                            });
                            setShowImageViewer(true);
                        }}>
                        <CropImage
                            resizeMode="contain"
                            className={Styles.swiper_img_style}
                            src={item}
                            cropOption={{ ratio: 0.5, width: PCMaxWidth, height: 414 }}
                            width={PCMaxWidth}
                            height={414}
                            // 保留，不然高度 414 会失效
                            style={{"height":"100.00000000000001rem"}}
                        />
                    </TouchableWithoutFeedback>
                    {/* H5仅首图渲染 */}
                    {index === 0 ? benifitRender : null}
                </View>
            );
        } else if (ImageUrlsArr && ImageUrlsArr.length === 1) {
            return (
                <View
                    style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',
                        width: isMobileDeviceValue ? '100%' : PCMaxWidth,
                        height: '100%',
                    }}
                    key={item}>
                    <TouchableWithoutFeedback onPress={() => setShowImageViewer(true)}>
                        <CropImage
                            // resizeMode={detailABValueMap?.isABdetailSwiperIamgePartB ? 'contain' : 'cover'}
                            resizeMode="contain"
                            className={Styles.swiper_img_style}
                            src={item}
                            cropOption={{ ratio: 0.5, width: PCMaxWidth, height: 414 }}
                            width={PCMaxWidth}
                            height={414}
                            // 保留，不然高度 414 会失效
                            style={{"height":"100.00000000000001rem"}}
                        />
                    </TouchableWithoutFeedback>
                    {benifitRender}
                </View>
            );
        } else {
            return null;
        }
    };

    const renderCustomIndicator = useMemoizedFn(props => {
        const lightFont = {
            color: videoStatus.seekableDuration && !props.swiperProps.curIndex ? 'rgba(255, 255, 255, 0.6)' : 'white',
        };
        return (
            <View
                className={Styles.swiper_customIndicator}
                style={{
                    width: 300,
                    right: 0,
                    paddingLeft: videoStatus.seekableDuration && !videoStatus.paused ? scaleW(19) : 0,
                }}>
                {videoStatus.seekableDuration && !videoStatus.paused ? (
                    <TouchableWithoutFeedback
                        onPress={() => {
                            setVideoStatus({
                                muted: !videoStatus.muted,
                            });
                        }}>
                        <KImage
                            source={{
                                uri: videoStatus.muted
                                    ? 'https://cdn-static.kwai.net/kos/s101/nlav11312/DzyfGeHQ_2024-07-19-14-55-16.png'
                                    : 'https://cdn-static.kwai.net/kos/s101/nlav11312/BJKVsyRl_2024-07-19-14-54-56.png',
                            }}
                            style={{"width":"5.797101449275363rem","height":"5.797101449275363rem","marginRight":"2.8985507246376816rem"}}
                        />
                    </TouchableWithoutFeedback>
                ) : (
                    <View />
                )}
                <View
                    style={{"flexDirection":"row","alignItems":"center","justifyContent":"center"}}>
                    {videoStatus.seekableDuration ? (
                        <TouchableWithoutFeedback
                            onPress={() => {
                                useDetailPageStore.setState({
                                    swiperImageIndex: 0,
                                });
                                setVideoStatus({
                                    paused: !videoStatus.paused,
                                });
                            }}>
                            <KImage
                                source={{
                                    uri: videoStatus.paused
                                        ? 'https://cdn-static.kwai.net/kos/s101/nlav11312/qXqdeDzn_2024-07-23-17-40-41.png'
                                        : 'https://cdn-static.kwai.net/kos/s101/nlav11312/DkUDjeye_2024-07-23-17-40-11.png',
                                }}
                                style={{"width":"5.797101449275363rem","height":"5.797101449275363rem","marginRight":"1.9323671497584543rem"}}
                            />
                        </TouchableWithoutFeedback>
                    ) : null}
                    <TouchableWithoutFeedback
                        onPress={() => {
                            if (showVideo && useDetailPageStore.getState().swiperImageIndex === 0) {
                                useDetailPageStore.setState({
                                    swiperImageIndex: 1,
                                });
                            }
                        }}>
                        <View className={Styles.swiper_customIndicator_content}>
                            {specImageIndex !== -1 && !!pageRawData.specs?.[0]?.itemSpecValues ? (
                                <View
                                    style={{"flexDirection":"row","alignItems":"center"}}>
                                    <Text
                                        numberOfLines={1}
                                        ellipsizeMode="tail"
                                        className={Styles.swiper_customIndicator_content_text}
                                        style={[lightFont, { maxWidth: scaleW(300) }]}>
                                        {`${pageRawData.specs[0].specName} : ${
                                            pageRawData.specs[0].itemSpecValues[specImageIndex]?.specValueName ?? ''
                                        }`}
                                    </Text>
                                    <View
                                        style={{"height":"1.9323671497584543rem","width":"0.24154589371980678rem","backgroundColor":"rgba(255, 255, 255, 0.20)","marginHorizontal":"0.9661835748792271rem"}}
                                    />
                                </View>
                            ) : null}
                            <Text className={Styles.swiper_customIndicator_content_text} style={lightFont}>
                                {props.swiperProps.curIndex + 1}
                            </Text>
                            <Text className={Styles.swiper_customIndicator_content_text} style={lightFont}>
                                /
                            </Text>
                            <Text className={Styles.swiper_customIndicator_content_text} style={lightFont}>
                                {props.swiperProps.total}
                            </Text>
                        </View>
                    </TouchableWithoutFeedback>
                </View>
            </View>
        );
    });
    const swiperRef = useRef(null);
    const getSwiperItems = () => {
        const list = Array.from(ImageUrlsArr) as (string | JSX.Element)[];
        // 如果命中实验，并且存在两个优质评论
        if (pageRawData?.abTest?.wordOfMouth && pageRawData?.comments?.length >= 2) {
            list.push(<CommentImage />);
        }
        // 如果有返回排行榜商品
        if (pageRawData?.masterPhotoCategoryRankPageInfo?.rankProducts?.length) {
            list.push(<RankImage />);
        }
        if (showVideo) {
            list.unshift(
                <View>
                    <SwiperVideo
                        uri={pageRawData.coverPhoto.photoUrl}
                        isPreview={showImageViewer}
                        onPress={() => setShowImageViewer(true)}
                        poster={pageRawData.coverPhoto.photoCoverUrl}
                    />
                    {videoStatus.seekableDuration && videoStatus.paused ? benifitRender : null}
                </View>
            );
        }
        return list;
    };
    const swiperItems = getSwiperItems();

    const onIndexChanged = (index: number) => {
        let _specImageIndex = index;
        if (showVideo) {
            index !== 0 &&
                setVideoStatus({
                    paused: true,
                });
            _specImageIndex = index - 1;
        }
        useDetailPageStore.setState({
            swiperImageIndex: index,
        });
        // 如果存在商品评价型图片, 当滑动到最后一张图片时，不影响其他的规格选择,只修改swiperImageIndex
        if (pageRawData?.abTest?.wordOfMouth && pageRawData?.comments?.length >= 2) {
            // 如果不存在排行榜
            if (index === swiperItems.length - 1) return;
            // 如果存在排行榜
            if (pageRawData?.masterPhotoCategoryRankPageInfo?.rankProducts?.length && index === swiperItems.length - 2) {
                return;
            }
        }
        // 如果不存在商品评价，但是有排行榜
        if (index === swiperItems.length - 1 && pageRawData?.masterPhotoCategoryRankPageInfo?.rankProducts?.length) {
            return;
        }
        setSpecImageIndex(_specImageIndex);
        logShowImgContiner(_specImageIndex, pageRawData.imageUrls.length);
        clickImgContiner(_specImageIndex, 1);
    };
    const renderImageSwiper = () => {
        return pageRawData.imageUrls ? (
            <ViewVisible onVisible={() => logShowImgContiner(0, pageRawData.imageUrls.length)}>
                <KSwiper
                    ref={swiperRef}
                    useScrollView={true}
                    kidtoken=""
                    autoPlay={false}
                    loop={false}
                    initialIndex={0}
                    scalable={true}
                    onIndexChanged={onIndexChanged}
                    customIndicator={renderCustomIndicator}
                    customStyle={{
                        swiperWidth: vwWithPC(100),
                        swiperHeight: vwWithPC(100),
                        // borderRadius: 8,
                        indicatorActiveColor: 'red',
                        indicatorColor: 'gray',
                    }}
                    data={swiperItems}
                    renderItem={renderSwiperItem}
                />
            </ViewVisible>
        ) : null;
    };

    useEffect(() => {
        swiperRef.current?.scrollTo(getStoreState().swiperImageIndex);
    }, [swiperImageIndex]);

    const getImagePreviewData = () => {
        const list = Array.from(ImageUrlsArr) as (string | JSX.Element)[];
        if (pageRawData?.abTest?.wordOfMouth && pageRawData.comments.length >= 2) {
            list.push(
                <View style={{"height":"100%","justifyContent":"center"}}>
                    <CommentImage ifClick={false} />
                </View>
            );
        }
        // 如果有返回排行榜商品
        if (pageRawData?.masterPhotoCategoryRankPageInfo?.rankProducts?.length) {
            list.push(<RankImage ifClick={false} />);
        }
        if (showVideo) {
            list.unshift(
                <View style={{"height":"100%","justifyContent":"center","backgroundColor":"black"}}>
                    <PreviewVideo uri={pageRawData.coverPhoto.photoUrl} poster={pageRawData.coverPhoto.photoCoverUrl} />
                </View>
            );
        }
        return list;
    };

    const imagePreviewData = getImagePreviewData();

    return (
        <PageContext.Provider value={{ Styles }}>
            <View className={Styles.swiper_wraper}>{renderImageSwiper()}</View>
            <ImagePreview
                autoPlay={false}
                useScrollView={true}
                customCloseIcon={() => {
                    return (
                        <View style={{"position":"absolute","width":"24.154589371980677rem","height":"24.154589371980677rem","paddingLeft":"4.830917874396135rem","paddingTop":"8.212560386473431rem","zIndex":10}}>
                            <MyImage imageSrc={CloseWithBackground} styleObj={{ width: 42, height: 42 }} />
                        </View>
                    );
                }}
                customStyle={{ indicatorTop: 44 }}
                images={imagePreviewData}
                beforeClose={() => {
                    console.log('close');
                    setShowImageViewer(false);
                }}
                boxStyle={{ position: 'fixed', zIndex: 999 }}
                startPosition={swiperImageIndex}
                onChange={(index: number) => {
                    setStoreState({ swiperImageIndex: index });
                    logShowImgFullScreenContiner(index, ImageUrlsArr.length);
                    clickImgContiner(index, 2);
                }}
                defaultSource={shoppingBag}
                visible={showImageViewer}
                closeable
                closeIconPosition={'top-left'}
                cropOption={{ ratio: 0.5 }}
                onClose={() => {
                    setShowImageViewer(false);
                }}
                // loop={ImageUrlsArr && ImageUrlsArr.length === 1 ? false : true}
                loop={false}
            />
        </PageContext.Provider>
    );
};

export default SwiperLine;
